import React from 'react';

import MissionControl from 'pages/MissionControl/MissionControl';
import { OperationTypes } from 'utils/enums/system-template';
import useOperationType from 'utils/hooks/use-operation-type';

type Props = Record<never, never>;

const HomeView: React.FC<Props> = () => {
  const { operationType } = useOperationType();

  if (operationType === OperationTypes.Broker) {
    /** This component is loaded lazily by use-routes.tsx, to avoid a Vite build conflict we make sure its imported lazily in here as well */
    const PerformanceDashboard = React.lazy(() => import('pages/PerformanceDashboard/PerformanceDashboard'));

    return <PerformanceDashboard></PerformanceDashboard>;
  }

  return <MissionControl></MissionControl>;
};

HomeView.displayName = 'HomeView';

export default HomeView;
